var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneicon = function SvgPhoneicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 1h3l1.5 3.75-1.875 1.125a8.25 8.25 0 0 0 3.75 3.75L10.25 7.75 14 9.25v3a1.5 1.5 0 0 1-1.5 1.5A12 12 0 0 1 1.25 2.5 1.5 1.5 0 0 1 2.75 1Z",
    fill: "#47516E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 1h3l1.5 3.75-1.875 1.125a8.25 8.25 0 0 0 3.75 3.75L10.25 7.75 14 9.25v3a1.5 1.5 0 0 1-1.5 1.5A12 12 0 0 1 1.25 2.5 1.5 1.5 0 0 1 2.75 1",
    stroke: "#47516E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPhoneicon;